import React, { FC } from 'react';
import { BulkResourceScheduling, ResourceScheduling } from './resource-scheduling';
import { L } from 'harmony-language';
import { ModalDialog } from '../../../shared/containers/modal-dialog';
import { PerformanceIconButton } from '../../drafts-loads-table-cells/performance-icons';
import { Load, Stop } from '../../../../types';
import { ConditionalResourceScheduling } from './conditional-resource-scheduling';
import { LoadEditableItems } from '../../hooks/use-load-editable-items';

interface ResourceSchedulingButtonProps {
    load?: Load;
    loadEditableItems: LoadEditableItems;
}

export const ResourceSchedulingButton: FC<ResourceSchedulingButtonProps> = (props) => {
    const { load, loadEditableItems } = props;
    const [modalOpen, setModalOpen] = React.useState(false);

    const onClose = () => {
        setModalOpen(false);
    }

    return (
        <>
            <PerformanceIconButton
                icon='person_search'
                onClick={() => setModalOpen(true)}
                size='small'
                color='default'
            />
            <ModalDialog
                title={L.resourceScheduling()}
                onClose={onClose}
                open={modalOpen}
            >
                {load
                    ? <ConditionalResourceScheduling
                        loadEditableItems={loadEditableItems}
                        load={load}
                        onClose={onClose}
                    />
                    : <ResourceScheduling loadEditableItems={loadEditableItems} />
                }
            </ModalDialog>
        </>
    );
};

interface BulkResourceSchedulingButtonProps {
    stops: Stop[];
}

export const BulkResourceSchedulingButton: FC<BulkResourceSchedulingButtonProps> = (props) => {
    const { stops } = props;
    const [modalOpen, setModalOpen] = React.useState(false);

    return (
        <>
            <PerformanceIconButton
                icon='person_search'
                onClick={() => setModalOpen(true)}
                size='small'
                color='default'
                buttonStyle={{ padding: 0, alignSelf: 'flex-end' }}
            />
            <ModalDialog
                title={L.resourceScheduling()}
                onClose={() => setModalOpen(false)}
                open={modalOpen}
            >
                <BulkResourceScheduling stops={stops} />
            </ModalDialog>
        </>
    )
}